<div class="select-wrapper" *ngIf="currentConfig && availableConfigs.length > 0">
	<select
		[ngModel]="currentConfig"
		(ngModelChange)="onChangeConfig($event)"
		class="select-dropdown professional-select bg-transparent forced">
		<option *ngFor="let configItem of availableConfigs" [ngValue]="configItem.config">
			{{ configItem.customerName }}{{ configItem.label ? ' (' + configItem.label + ')' : '' }}
		</option>
	</select>

</div>